export function getH5Domain () {
  console.log(process.env.CUSTOM_ENV)
  switch (process.env.CUSTOM_ENV) {
    case 'test': {
      console.log('test')
      return 'https://t-h5.lszzg.com/wap/'
    }
    case 'pre': {
      console.log('pre')
      return 'https://p-h5.lszzg.com/wap/'
    }
    case 'prd': {
      console.log('prd')
      return 'https://h5.leshuazf.com/wap/'
    }
    default: {
      console.log('default')
      return 'https://t-h5.lszzg.com/wap/'
    }
  }
}
